module.exports = {"430202001":"月塘街道","430202002":"茨菇塘街道","430202003":"宋家桥街道","430202004":"桂花街道","430202005":"金山街道","430202100":"仙庾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430202.json
// module id = 1938
// module chunks = 0